module.exports = __webpack_public_path__ + "img/time.2df2a766.png";